import {Component, EventEmitter, Output} from '@angular/core';
import {ButtonComponent} from '../../../../elements/button/button.component';

@Component({
  selector: 'app-main-section',
  imports: [
    ButtonComponent
  ],
  templateUrl: './main-section.component.html',
  styleUrl: './main-section.component.scss'
})
export class MainSectionComponent {
  @Output() emitScroll: EventEmitter<any> = new EventEmitter();
}
